/**
 * SourcePill — clickable citation badge linking to a source document.
 */

import { Badge } from "@/ui/primitives/badge";
import { FileText } from "lucide-react";

interface SourceCitation {
  doc: string;
  docId?: string;
  page?: number;
}

interface SourcePillProps {
  sources: SourceCitation[];
  onViewDocument?: (docId: string) => void;
}

export function SourcePills({ sources, onViewDocument }: SourcePillProps) {
  if (!sources || sources.length === 0) return null;

  return (
    <div className="mt-1.5 flex flex-wrap gap-1">
      {sources.map((s, i) => {
        const shortName =
          s.doc.length > 35 ? s.doc.slice(0, 33) + "\u2026" : s.doc;
        const label = s.page ? `${shortName} p.${s.page}` : shortName;
        const docId = s.docId;

        return (
          <Badge
            key={i}
            color="gray"
            variant="outline"
            size="sm"
            className={
              docId && onViewDocument
                ? "cursor-pointer transition-colors hover:bg-muted/50"
                : ""
            }
            title={s.doc}
            onClick={
              docId && onViewDocument ? () => onViewDocument(docId) : undefined
            }
          >
            <FileText className="h-2.5 w-2.5" />
            {label}
          </Badge>
        );
      })}
    </div>
  );
}
